<template>
  <div :class="'my-download-list' + expirationClass" v-if="data">
    <div class="check-style" v-if="editorMode">
        <input type="checkbox" @click.stop="checkedDownload(data.contentid)" class="check-blue-dark" name="chkSeq" :value="data.contentid" :checked="isChecked"
               :id="'ch-'+data.contentid"><label :for="'ch-'+data.contentid"><span>선택</span></label>
    </div>
    <div class="my-download-text">
      <p class="my-down-tag">
        <i v-if="data.contenttype === 'vod'" class="tag-vod">VOD</i>
        <i v-if="data.contenttype === 'movie'" class="tag-movie">영화</i>
      </p>
      <p class="con-tit"><template v-if="data.episodenumber">{{ data.episodenumber }}회</template> {{data.programtitle}}</p>
      <p class="con-text01">
        <span>이용</span>
        <span class="title-dot"></span>
        <span>{{data.downloaddatetime}}</span>
      </p>
      <p class="con-text01">
        <span>만료</span>
        <span class="title-dot"></span>
        <span>{{data.enddatetime}}</span>
      </p>
    </div>
    <div class="my-download-num"><span>
      {{data.downloadcount.split('/')[0]}}</span>/{{data.downloadcount.split('/')[1]}}</div>
    <div class="my-download-btn">
      <button @click="down(data)">다운로드</button>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import breakDown from '@/mixins/breakdown.mixin'
import { getMovieContentsDetail, getVodContentsDetail } from '@/common/utils/request'
import { goVerifyAdultPageForDownload, isAdultContent, userAdultVerifiedInfo } from '@/common/utils/common'
import cookie from '@/common/utils/cookie'
import constant from '@/common/resources/constant'
export default {
  name: 'BreakListDownload',
  mixins: [
    breakDown
  ],
  props: {
    data: {
      type: Object
    },
    index: {
      type: Number
    },
    editorMode: {
      type: Boolean
    },
    viewMode: {
      type: String
    },
    setCheckFn: {
      type: Function
    },
    setDownloadEventFn: {
      type: Function
    }
  },
  computed: {
    isChecked () {
      return this.data.checked
    },
    expirationClass () {
      const [downloadCount, totalCount] = _.get(this.data, 'downloadcount', '0/0').split('/')
      return Number(downloadCount) >= Number(totalCount) ? ' expire' : ''
    }
  },
  methods: {
    down (contentInfo) {
      const [downloadCount, totalCount] = _.get(this.data, 'downloadcount', '0/0').split('/')
      if (Number(downloadCount) >= Number(totalCount)) {
        alert('더이상 다운로드를 하실수 없습니다.')
      } else {
        const contentid = _.get(contentInfo, 'contentid', '')
        const contentType = _.get(this.data, 'contenttype', '')
        const contentsDetailApi = contentType === 'movie' ? getMovieContentsDetail({ movieid: contentid }) : getVodContentsDetail({ contentid })
        contentsDetailApi.then( async ({ data }) => {
          const targetAge = _.get(data, 'targetage', '0')
          const { isAdultVerified, expire } = await userAdultVerifiedInfo()
          if (isAdultVerified) {
            cookie.setItem('verifiedAdult', '1', expire, constant.URL_COOKIE_DOMAIN, '/')
          }
          if (isAdultContent(targetAge) && cookie.isNotVerifiedAdultUser()) {
            goVerifyAdultPageForDownload({ referer: this.$route.fullPath, enter: this.$route.fullPath })
          } else {
            window.showDownloadLayout(data, contentType)
          }
        })
      }
    },
    checkedDownload (contentid) {
      this.setCheckFn(contentid)
    }
  }
}
</script>

<style scoped>

</style>
